import { resolvePortalApiOrigin } from 'constants/apiOrigins'

export const isLocal = window.location.hostname.includes('localhost')

const apiOrigin = resolvePortalApiOrigin(process.env.VITE_FIREBASE_PROJECT_ID)

/** Legacy callers use `/api` without the `v1` segment (axios uses `apiBaseUrl` instead). */
export const API_URL = `${apiOrigin}/api`

export const socketUrl = apiOrigin

export { auth, app, firebaseConfig } from './firebase'
